import React from 'react';
import { Box, useColorMode, VStack } from 'native-base';
import { faFacebook, faInstagram, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { SpIcon } from '~/shared/Icon';
import { Caption } from '~/shared/Typography';
import Pressable from '~/shared/Pressable';

type ReferSocialMediaProps = {
    copyToClipboard: (target?: string) => void;
};

const ReferSocialMedia = ({ copyToClipboard }: ReferSocialMediaProps) => {

    const { colorMode } = useColorMode();
    let social_facebook_icon_color;
    let social_twitter_icon_color;
    let social_linkedin_icon_color;
    let social_instagram_icon_color;

    if (colorMode === 'light') {
        social_facebook_icon_color = '#3b5998';
        social_twitter_icon_color = '#000000';
        social_linkedin_icon_color = '#0077b5';
        social_instagram_icon_color = '#e4405f';
    } else {
        social_facebook_icon_color = '#3b5998';
        social_twitter_icon_color = '#FFFFFF';
        social_linkedin_icon_color = '#0077b5';
        social_instagram_icon_color = '#e4405f';
    }

    const logicColorSocialMedia = (socialMedia: string) => {

        if (socialMedia === 'facebook') {
            return social_facebook_icon_color;
        }

        if (socialMedia === 'twitter') {
            return social_twitter_icon_color;
        }

        if (socialMedia === 'linkedin') {
            return social_linkedin_icon_color;
        }

        if (socialMedia === 'instagram') {
            return social_instagram_icon_color;
        }

        return 'black';
    };

    return (
        <VStack w={'100%'} space={2}>
            <Caption
                textAlign={'center'}
                text='refer.text_social_media'
            />
            <Box
                flexDirection={'row'}
                alignItems='center'
                justifyContent={'space-evenly'}
            >
                {
                    dummySocial.map((social, index) => {

                        return (
                            <Pressable key={`${index}-${social}`} onPress={() => copyToClipboard(social.link)}>
                                <SpIcon
                                    color={logicColorSocialMedia(social.name)}
                                    icon={social.icon} />
                            </Pressable>
                        );
                    }
                    )
                }
            </Box>
        </VStack>
    );
};

export default ReferSocialMedia;

const dummySocial = [
    {
        name: 'facebook',
        icon: faFacebook,
        link: 'https://www.facebook.com'
    }, {
        name: 'twitter',
        icon: faXTwitter,
        link: 'https://twitter.com'
    }, {
        name: 'instagram',
        icon: faInstagram,
        link: 'https://www.instagram.com'
    }, {
        name: 'linkedin',
        icon: faLinkedin,
        link: 'https://www.linkedin.com'
    }
];
